import React from 'react';
import useIntersectionAnimation from '@helpers/useIntersectionAnimation';
import { animationPresets } from '@styles/animations';
import { AnimatedElement } from './animated-element.styled';

interface AnimatedElementProps {
  children: React.ReactNode;
  animationType?: keyof typeof animationPresets;
  delay?: number;
  threshold?: number;
  rootMargin?: string;
  once?: boolean;
  className?: string;
}

const AnimatedElementComponent: React.FC<AnimatedElementProps> = ({
  children,
  animationType = 'fadeIn',
  delay = 0,
  threshold = 0.1,
  rootMargin = '0px',
  once = true,
  className,
}) => {
  const { ref, animationClass } = useIntersectionAnimation({
    threshold,
    rootMargin,
    once,
  });

  return (
    <AnimatedElement
      ref={ref}
      className={`${animationClass} ${className || ''}`}
      $animationType={animationType}
      $delay={delay}
    >
      {children}
    </AnimatedElement>
  );
};

export default AnimatedElementComponent;
